<BI-grid-layout [cols]="['100%']">
  <BI-grid-layout-item *ngIf="(PageTitle??'' != '')" [row]="1" [col]="1">
    <div class="titles">
      <h4>{{PageTitle}}&nbsp; 
      </h4>
      <h6>{{RowTitle}}</h6>
      <bi-favorite-button></bi-favorite-button>
    </div>
  </BI-grid-layout-item>

  <BI-grid-layout-item [row]="2" [col]="1">
    <div class="nav-btns-container d-flex justify-content-start">
      <div class="scroll-left" (click)="scrollLeft()"><img src="assets/icons/left_arrow_button.svg" alt="" ></div>
      <div [dir]="biService.getDir() ? 'rtl': 'ltr'" class="justify-content-between d-flex text-center px-0 holder">
        <button *ngIf="navButtons.add?.visibility || !navButtons?.add" kendoButton [id]="'Add_'+DomID"
          [disabled]="!CanInsert || !GetErpawarePermission()" fillMode="none" class="nav-btn px-2" (click)="AddRow()"
          imageUrl="assets/icons/add_black_24dp.svg">
          <div class="mobile-hidden">{{"add"|translate}}</div>
        </button>
        <button *ngIf="!navButtons?.save || navButtons.save?.visibility" kendoButton [id]="'Save_'+DomID"
          [disabled]="(!CanUpdate && !CanInsert) || !GetErpawarePermission()" fillMode="none"
          [ngClass]="{'nav-save-btn': (navButtons.add?.visibility || !navButtons.add)}" class="nav-btn px-3"
          (click)="Save()" value="Save" imageUrl="assets/icons/save_black_24dp (2).svg">
          <div class="mobile-hidden">{{"Save" | translate}}</div>
        </button>
        <button *ngIf="!navButtons?.delete || navButtons.delete?.visibility" kendoButton [id]="'Delete_'+DomID"
          [disabled]="!CanDelete || !GetErpawarePermission()" fillMode="none" class="nav-delete-btn nav-btn px-2"
          (click)="DeleteRow()" imageUrl="assets/icons/delet.svg">
          <div class="mobile-hidden">{{"Delete"|translate}}</div>
        </button>
        <button *ngIf="!navButtons?.cancel || navButtons.cancel?.visibility" kendoButton [id]="'Cancel_'+DomID"
          [disabled]="!CanUpdate && !CanInsert" fillMode="none"
          [ngClass]="{'nav-cancel-btn': (!navButtons.delete || navButtons.delete?.visibility)}" class="nav-btn px-2"
          (click)="Cancel()" imageUrl="assets/icons/cancel_black_24dp (2).svg">
          <div class="mobile-hidden">{{"Cancel"|translate}}</div>
        </button>
        <button *ngIf="navButtons.print?.visibility" kendoButton [id]="'Print_'+DomID" (click)="Print()" fillMode="none"
          class="nav-btn px-2" imageUrl="assets/icons/print_black_24dp.svg">
          <div class="mobile-hidden">{{"Print"|translate}}</div>
        </button>
        <button *ngIf="!navButtons?.attach || navButtons.attach?.visibility" kendoButton [id]="'Attachment_'+DomID"
          fillMode="none" class="nav-btn px-2" (click)="Attachment()" [disabled]="navButtons.attach?.disable??false"
          imageUrl="assets/icons/attach_file_black_24dp.svg">
          <div class="mobile-hidden">{{"Attachments"|translate}}</div>
        </button>
        <button *ngIf="navButtons?.info?.visibility || !navButtons?.info" kendoButton [id]="'Info_'+DomID"
          fillMode="none"
          [ngClass]="{'nav-info-btn': (navButtons.print?.visibility) || (navButtons.attach?.visibility)}"
          class="nav-btn px-2" (click)="Info()" imageUrl="assets/icons/info_black_24dp.svg">
          <div class="mobile-hidden">{{"Info"|translate}}</div>
        </button>
        <ng-content></ng-content>

   <!-- dynamic cols -->
        <button #trigger="matMenuTrigger" *ngIf="navButtons?.ColView?.visibility || !navButtons?.ColView" kendoButton [id]="'ColView_'+DomID"
        mat-icon-button [matMenuTriggerFor]="menu" class="viewCols-btn mx-1">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="OnViewselectionChanges(1); $event.stopPropagation()">
            <span><img src="assets/icons/ph--text-columns-one.svg" alt=""></span><span>{{ "One-column" | translate }}</span>
          </button>
          <button mat-menu-item (click)="OnViewselectionChanges(2); $event.stopPropagation()">
            <span><img src="assets/icons/ph--text-columns.svg" alt=""></span><span>{{ "Two-columns" | translate }}</span>
          </button>
          <button mat-menu-item (click)="OnViewselectionChanges(3); $event.stopPropagation()">
            <span><img src="assets/icons/ph--text-columns-three.svg" alt=""></span><span>{{ "Three-columns" | translate }}</span>
          </button>
          <button mat-menu-item (click)="OnViewselectionChanges(4); $event.stopPropagation()">
            <span><img src="assets/icons/ph--text-columns-four.svg" alt=""></span><span src="assets/icons/ph--text-columns-four.svg">{{ "Four-columns" | translate }}</span>
          </button>
          <div class="d-flex justify-content-center border-top">
            <button class="primary-btn mt-1" (click)="SaveLayoutForScreenClicked()">{{'SetAsDefaultLayout'|translate}}</button>
          </div>
        </mat-menu>
      </div>
      <div class="scroll-right" (click)="scrollRight()"><img src="assets/icons/left_arrow_button.svg" alt="" ></div>
    </div>
  </BI-grid-layout-item>

</BI-grid-layout>

<kendo-dialog [title]="('RecordInformation' | translate)" *ngIf="opened" (close)="Close()" [maxWidth]="700">
  <div class="container">
    <div class="row overflow-hidden">
      <div class="col-md-5 col-12 mb-1 ml-2">
        <span class="key ml-2">{{"CreatedBy" | translate}} </span>
        <span class="value">{{CreatedBy}}</span>
      </div>
      <div class="col-md-7 col-12 mb-1 ml-2">
        <span class="key ml-2">{{"CreatedOn" | translate}} </span>
        <span class="value">{{CreatedOn?.toLocaleString() ?? ""}}</span>
      </div>
      <div class="col-md-5 col-12 mb-1 ml-2">
        <span class="key ml-2">{{"ModifiedBy" | translate}} </span>
        <span class="value">{{ModifiedBy}}</span>
      </div>
      <div class="col-md-7 col-12 mb-1 ml-2">
        <span class="key ml-2">{{"ModifiedOn" | translate}} </span>
        <span class="value">{{ModifiedOn?.toLocaleString() ?? ""}}</span>
      </div>
      <div class="col-md-5 col-12 mb-1 ml-2">
        <span class="key ml-2">{{"BUID" | translate}} </span>
        <span class="value">{{BUID}}</span>
      </div>
      <div class="col-md-7 col-12 mb-1 ml-2">
        <span class="key ml-2">{{"RecordSource" | translate}} </span>
        <span class="value">{{RecordSourceEnum[RecordSource]}}</span>
      </div>
    </div>
  </div>
</kendo-dialog>